// The default environment values
export const EnvironmentDefaults = {
  tenant  : 'none',
  custom  : 'fino',
  stage   : null, // = production
  baseUrl : '/',
  build   : +new Date() // pseudo cache busting
};

// Host names of tunnels
export const Tunnels = [
  'ngrok.io'
];



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-environment/src/environment.constants.js